export default "__VITE_ASSET__CQaKJdbj__"